import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import ReactSelect from 'react-select';
import { FaChevronDown } from 'react-icons/fa';

import { RadioInput } from 'components/ui/RadioInput';
import reactSelectStylesConfig from 'lib/react-select';
import { reactQueryConfig } from 'lib/react-query';
import { AnswerInfo, TakeExam } from 'api/students/types';
import { QuizResultResponse } from 'api/quiz/types';
import { StudentQuizTakenTypes } from 'api/analytics/types';
import { removeStudentQuizTaken } from 'api/analytics';
import { QuizResut } from './QuizResut';
import { SecurityModal } from 'components/util/SecurityModal';

interface Props {
  attempts?: QuizResultResponse[] | undefined;
  quizId: string | null;
}

export const QuizReview = ({ attempts, quizId }: Props) => {
  const [activeQuizReview, setActiveQuizReview] = useState<{ label: string; value: QuizResultResponse | null }>({
    label: '',
    value: null
  });

  const { mutate: deleteAttempt } = useMutation(removeStudentQuizTaken, {
    onSuccess: () => {
      reactQueryConfig.refetchQueries([`quiz-taken`]);
      reactQueryConfig.refetchQueries(['student-quiz-taken']);
      reactQueryConfig.refetchQueries(['student-quiz-attempts']);
    }
  });

  useEffect(() => {
    if (attempts?.length) {
      setActiveQuizReview({
        value: attempts[0],
        label: 'Attempt1'
      });
      return;
    }
    setActiveQuizReview({
      value: null,
      label: 'No attempts'
    });
  }, [attempts]);

  const onClose = () => {};
  const [isOpenDeleteSecurityModal, setIsOpenDeleteSecurityModal] = useState(false);
  console.log("this is attempt", activeQuizReview.value, quizId);
  return (
    <>
      <div className="flex items-start flex-wrap gap-4 mb-6">
        <div>
          <h3 className="font-medium mb-1">Select attempt:</h3>
          <ReactSelect
            styles={reactSelectStylesConfig}
            className="w-48 mr-6"
            value={activeQuizReview}
            options={attempts?.map((temp, i) => ({ value: temp, label: `Attempt ${i + 1}` }))}
            onChange={(val: any) => {
              setActiveQuizReview(val);
            }}
          />
        </div>
        {/*
        Hide: this part for clients requirement
        */}
        <div>
          <h3 className="font-medium mb-1">Delete this attempt:</h3>
          <button
            className="secondaryBtn"
            onClick={() => {
              setIsOpenDeleteSecurityModal(true);
            }}
          >
            Delete
          </button>
          {isOpenDeleteSecurityModal && (
            <SecurityModal
              btnText="Delete"
              close={() => setIsOpenDeleteSecurityModal(false)}
              onClick={() => {
                if (activeQuizReview.value?.id && quizId) deleteAttempt({ quizTakenID: activeQuizReview.value.id, quizId });
                setIsOpenDeleteSecurityModal(false);
              }}
              text="Are you sure you want to delete this attempt?"
            />
          )}
        </div>
      </div>
      {activeQuizReview.value ? <QuizResut data={activeQuizReview.value} onClose={onClose} analysis /> : <></>}
    </>
  );
};
